import { CIMSPage } from '@cims-online/shared'
import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { HelpMessage } from 'utils/constants'
import { CASSubtype } from '../../../SubtypesTableContext'

export function useExpandOptions(): ExpandOptions<CASSubtype> {
  return {
    expandable: ({ submittals }) => submittals.length > 0,
    render: ({ id, submittals }) => {
      return {
        additionalInfo: [
          {
            label: 'Associated Submittals',
            help: HelpMessage.CAS.SubTypes.AssociatedSubmittals,
            type: 'deepLinks',
            showMore: { key: id },
            links: submittals.map(
              ({ packageName, deleted, id, packageNumber }) => ({
                label: packageNumber,
                tooltip: packageName,
                page: CIMSPage.CASTracker,
                deep: { recordId: id, deleted },
              })
            ),
          },
        ],
      }
    },
  }
}
